/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import React, { useState, useEffect } from 'react';
import { Modal, Button, Spin, Collapse, Divider, Select, Switch } from 'antd';
import { useAgentId } from '@hooks/useAgentId';
import releasesAPI from '@api/releases';

let evaluationBundle;
const EvaluateCorpusModal = ({ selectedCorpusId }) => {
  const { Panel } = Collapse;
  const { Option } = Select;

  const { agentId } = useAgentId();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorsToShow, setErrorsToShow] = useState(null);
  const [languages, setLanguages] = useState(null);
  const [evaluation, setEvaluation] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [addNoneInput, setAddNoneInput] = useState(true);
  const [nluThreshold, setNLUThreshold] = useState(0.5);
  const [testMode, setTestMode] = useState('training');
  const [lastBundle, setLastBundle] = useState(null);

  const showModal = () => {
    console.log('showModal > setSelectedLanguage empty');
    setSelectedLanguage('');
    setLanguages(null);
    setEvaluation(null);
    setIsModalVisible(true);
    setLastBundle(null);
    setErrorsToShow(null);
    setIsLoading(false);
  };

  const processErrors = (data, currentLanguage) => {
    let errors = [];
    if (data && data?.language[currentLanguage]) {
      for (let error of data.language[currentLanguage].errors) {
        errors.push({
          intent: error.input,
          expected: error.expectedIntent,
          prediction: error.prediction.intent,
          predictionScore: error.prediction.score,
        });
      }
    }
    setErrorsToShow(errors);
  };

  const processLanguages = data => {
    const languages = [];
    const erroredLanguages = [];

    for (let languageKey in data?.language) {
      languages.push(languageKey);
      if (data?.language[languageKey]?.errors?.length) {
        erroredLanguages.push(languageKey);
      }
    }

    let currentLanguage;
    if (languages.length) {
      currentLanguage = languages[0];
      setSelectedLanguage(currentLanguage);
    } else {
      setSelectedLanguage('');
      currentLanguage = '';
    }
    setLanguages(languages);
    return currentLanguage;
  };

  const handleOk = () => {
    // value when there is no selectedCorpusId
    setIsLoading(true);

    releasesAPI
      .evaluateCorpusVersion(
        agentId,
        selectedCorpusId ? selectedCorpusId : 'draft',
        addNoneInput,
        nluThreshold,
        testMode
      )
      .then(response => {
        console.log('entra con response', response);
        const { data } = response;
        evaluationBundle = data;
        // FOR DEVELOPMENT:
        // evaluationBundle = mockResponse;

        setLastBundle(evaluationBundle);
        processLanguages(evaluationBundle);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
    // setIsModalVisible(false);
  };

  useEffect(() => {
    if (lastBundle && selectedLanguage) {
      const currentEvaluation = lastBundle?.language[selectedLanguage];
      if (currentEvaluation) {
        setEvaluation(currentEvaluation);
      } else {
        setEvaluation(null);
      }
      console.log('evaluation > currentLanguage', selectedLanguage);
      processErrors(lastBundle, selectedLanguage);
    }
  }, [selectedLanguage, lastBundle]);

  const handleCancel = () => {
    setErrorsToShow(null);
    console.log('handleCancel > setSelectedLanguage empty');
    setSelectedLanguage('');
    setEvaluation(null);
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        style={{ marginRight: '1rem' }}
        type="secondary"
        className="uppercase custom-button-primary "
        onClick={showModal}
      >
        Evaluate corpus
      </Button>
      <Modal
        title="Evaluate version"
        visible={isModalVisible}
        onOk={handleOk}
        okText="EVALUATE"
        onCancel={handleCancel}
      >
        <div style={{ border: '0.5px solid black', padding: '10px', backgroundColor: '#fafafa' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
            <p style={{ marginRight: '20px', minWidth: '150px' }}>Add none inputs</p>
            <Switch checked={addNoneInput} onChange={() => setAddNoneInput(!addNoneInput)} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
            <p style={{ marginRight: '20px', minWidth: '150px' }}>NLU Threshold:</p>
            <Select
              defaultValue={nluThreshold}
              onChange={v => {
                setNLUThreshold(v);
              }}
            >
              {[0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1].map(value => (
                <Option value={value} key={value}>
                  {value}
                </Option>
              ))}
            </Select>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
            <p style={{ marginRight: '20px', minWidth: '150px' }}>Test Mode</p>
            <Select
              defaultValue={testMode}
              onChange={v => {
                setTestMode(v);
              }}
            >
              <Option value={'training'}>Training</Option>
              <Option value={'mixed'}>Mixed</Option>
              <Option value={'test'}>Test</Option>
            </Select>
          </div>
        </div>
        {isLoading && <Spin size="large" style={{ width: '100%' }} />}
        {languages?.length && (
          <>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginBottom: '10px' }}>
              <div style={{ marginRight: '20px', minWidth: '150px' }}>Language detail: </div>
              <Select
                defaultValue={selectedLanguage}
                onChange={v => {
                  console.log('onChange > setSelectedLanguage ', v);
                  setSelectedLanguage(v);
                }}
              >
                {languages.map(lang => (
                  <Option key={lang} value={lang}>
                    {lang}
                  </Option>
                ))}
              </Select>
            </div>
          </>
        )}
        {evaluation && (
          <ul>
            <li>Success rate: {evaluation.successRate}%</li>
            <li>Total tests: {evaluation.total}</li>
            <li>Duration: {evaluation.duration}</li>
          </ul>
        )}
        {Boolean(errorsToShow?.length) && (
          <>
            <div style={{ fontWeight: 'bold', marginTop: '10px' }}>DETECTED PROBLEMS</div>
            <Collapse accordion ghost>
              {errorsToShow.map((error, i) => (
                <Panel header={<span className="flow-error-header">{error.expected}</span>} key={i}>
                  <div>
                    Sentence:<b> {error.intent}</b>
                  </div>
                  <Divider />
                  <div>
                    Assigned to:<b style={{ color: 'red' }}> {error.prediction}</b>
                  </div>
                  <div>
                    with a score of : <b>{error.predictionScore}</b>
                  </div>
                  <Divider />
                  <div>
                    Expected assignment: <b style={{ color: 'green' }}>{error.expected}</b>
                  </div>
                </Panel>
              ))}
            </Collapse>
          </>
        )}
      </Modal>
    </>
  );
};

export default EvaluateCorpusModal;
